module.exports = __webpack_public_path__ + "img/127.e3d2047a.png";